<div [appTooltip]="getTransactionStatusTranslation(status)">
  <ng-container [ngSwitch]="status">
    <svg-icon
      *ngSwitchCase="TransactionStatus.COMPLETED"
      [src]="iconFolder + 'checkmark-circle.svg'"
      svgClass="icon-checkmark"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.USED"
      [src]="iconFolder + 'checkmark-circle.svg'"
      svgClass="icon-checkmark"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.CREATED"
      [src]="iconFolder + 'checkmark-circle.svg'"
      svgClass="icon-checkmark"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.VERIFIED"
      [src]="iconFolder + 'checkmark-circle.svg'"
      svgClass="icon-checkmark"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.OK"
      [src]="iconFolder + 'checkmark-circle.svg'"
      svgClass="icon-checkmark"
    />

    <svg-icon
      *ngSwitchCase="TransactionStatus.NEW"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.SENT"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.PENDING"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.NOTIFIED"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.WAITING"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />
    <svg-icon
      *ngSwitchCase="TransactionStatus.BEFORE_SEND"
      [src]="iconFolder + 'clock-alt-circle.svg'"
      svgClass="icon-clock-alt"
    />

    <svg-icon *ngSwitchCase="TransactionStatus.ERROR" [src]="iconFolder + 'warning.svg'" svgClass="icon-warning" />

    <svg-icon
      *ngSwitchCase="TransactionStatus.CANCELLED"
      [src]="iconFolder + 'cross-circle.svg'"
      svgClass="icon-cross"
    />
  </ng-container>
</div>
